import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { auth } from "../services/api";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Fade,
  Alert,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your email...");
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState<"success" | "error" | "loading">(
    "loading"
  );

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setMessage("Invalid verification link.");
      setStatus("error");
      setLoading(false);
      return;
    }

    const verify = async () => {
      try {
        const res = await auth.verifyEmail(token);
        setMessage(res.data.message || "Your email has been verified!");
        setMessage("Your email has been verified!");
        setStatus("success");

        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } catch (err: any) {
        setMessage(err.response?.data?.message || "Verification failed.");
        setStatus("error");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [searchParams, navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ background: "linear-gradient(to bottom right, #e3f2fd, #ede7f6)" }}
    >
      <Fade in timeout={500}>
        <Card sx={{ maxWidth: 400, p: 3, borderRadius: 3, boxShadow: 4 }}>
          <CardContent sx={{ textAlign: "center" }}>
            {status === "loading" && (
              <>
                <CircularProgress color="primary" size={50} sx={{ mb: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Checking your verification link...
                </Typography>
              </>
            )}

            {status === "success" && (
              <Alert
                severity="success"
                icon={<CheckCircleIcon fontSize="inherit" />}
                sx={{ mb: 2 }}
              >
                {message}
              </Alert>
            )}

            {status === "error" && (
              <Alert
                severity="error"
                icon={<ErrorIcon fontSize="inherit" />}
                sx={{ mb: 2 }}
              >
                {message}
              </Alert>
            )}

            {!loading && (
              <>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  Redirecting you to login page...
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2,
                    textTransform: 'none'
                   }}
                  onClick={() => navigate("/login")}
                >
                  Go to Login Now
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </Fade>
    </Box>
  );
};

export default VerifyEmail;
